import { NavBar } from '../../../themes/components/Navbar';
import { Sidebar } from '../../../themes/components/Sidebar';
import { Toaster } from 'react-hot-toast';
import { ChartFaturamento } from '../components/ChartFaturamento';
import { ChartPedidos } from '../components/ChartPedidos';
import { ChartPositivacao } from '../components/ChartPositivacao';
import { ChartProdutosAtendidos } from '../components/ChartProdutosAtendidos';
import { useState } from 'react';
import { Typography } from '@material-ui/core';
import { SelectDropdown } from '../../../themes/components/SelectDropdown';

export const Dashboard = (props) => {

    const [estoque, setEstoque] = useState("GA");
    const [iEstoque, setIEstoque] = useState("2");
    const optEstoque = [
        { "cod": "2", "nome": "GA" },
        { "cod": "4", "nome": "AB" }
    ];

    function getCodEstoque(text) {
        let sit = "";
        optEstoque.forEach((opt) => {
            if (opt.nome === text) {
                sit = opt.cod;
            }
        })
        return sit;
    }

    function getEstoqueList() {
        let temp = []
        optEstoque.forEach((opt) => {
            temp.push(opt.nome)
        })
        return temp;
    }
    return (
        <div className="site">
            <Sidebar />
            <div className="main-content">
                <div className="main-content-dashboard">
                    <NavBar />
                    <div className="charts-area-dashboard">
                        <div className="form-group">
                            <div style={{ width: '98%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <Typography style={{ marginRight: '0.5em', marginBottom: '0.5em', whiteSpace: 'nowrap' }}>Empresa</Typography>
                                <div style={{ width: '10em', height: '5em', border: 'none', borderRadius: '5px', fontSize: '0.9em' }}>
                                    <SelectDropdown
                                        value={estoque}
                                        id="seleciona-combobox-estoque"
                                        options={getEstoqueList()}
                                        label={(option) => option}
                                        onChange={(event, newInputValue) => {
                                            setEstoque(newInputValue);
                                            setIEstoque(getCodEstoque(newInputValue));
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <ChartFaturamento estoque={iEstoque}/>
                        <ChartPedidos estoque={iEstoque}/>
                        {/*
                        <div className="dashboard-columns">
                            <ChartPositivacao />
                            <ChartProdutosAtendidos />
                            <ChartProdutosAtendidos />
                        </div>
                        */}
                    </div>
                </div>
            </div>
            <Toaster />
        </div>
    )
}